<template>
    <div>
        <div
            v-if="notificationCount > 0"
            v-for="notification in filteredNotifications"
            v-bind:key="notification.id"
            class="flash-notice shadow-md bg-gray-50"
        >
            <div class="flex">
                <div class="flash-notice-message">
                    {{ notification.notice }}
                </div>
                <div
                    class="ml-4 shrink-0 flash-notice-icon cursor-pointer"
                    @click="updateNotification(notification)"
                >
                    <i
                        class="fad fa-check-circle fa-2x hover:text-emerald-700 text-emerald-400"
                    ></i>
                </div>
            </div>
        </div>
        <div
            class="my-3 text-center"
            v-if="notificationCount > showNotificationCount"
        >
            <div class="cursor-pointer" @click="showNotificationCount += 5">
                Show More ...
                <span class="text-xs text-gray-400"
                    >({{ notificationCount - showNotificationCount }})</span
                >
            </div>
        </div>
        <help-notice
            v-else-if="notificationCount == 0"
            notice-text="No notifications! You're all caught up."
            notice-type="info"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "Notifications",
    data: function () {
        return {
            showNotificationCount: 5,
        };
    },
    mounted() {
        this.$store.dispatch("fetchNotifications");
    },
    methods: {
        updateNotification(notification) {
            this.$store.dispatch("updateNotification", notification);
        },
    },
    computed: {
        ...mapGetters(["notifications"]),
        notificationCount() {
            return this.notifications.length;
        },
        filteredNotifications() {
            return this.notifications.slice(0, this.showNotificationCount);
        },
    },
};
</script>

<style scoped></style>
